module.exports = __webpack_public_path__ + "img/Art12_il2008006-001_lower.09f0f7ad.jpg";